const zIndices = {
  header: 600,
  mobileNavOverlay: 700,
  mobileNavButton: 800,
  scrollToTop: 900,
  toast: 1000,
};
export default zIndices;
